export default __webpack_public_path__ + "static/media/like_btn.f3192d8c.svg";